import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/modules/shared-activities.constants";
import { GetSharedActivitiesResponse } from "../../models/customers/shared-activities.models";


@autoinject()
export class SharedActivitiesService {

    constructor(private requestClient: RequestClientService) { }

    public getActivities(customerId: number): Promise<GetSharedActivitiesResponse> {
        return this.requestClient.post<GetSharedActivitiesResponse>(Urls.GetActivities, {}, { customerId: customerId });
    }

    public addActivity(request: { sharedActivityId?: number, byCustomerId: number, byBusinessUnitId: number, withCustomerId: number, withBusinessUnitId: number, EntityTypeId: number }): Promise<GetSharedActivitiesResponse> {
        return this.requestClient.post<GetSharedActivitiesResponse>(Urls.AddActivity, {}, request);
    }

    public deleteActivity(id: number, customerId: number) : Promise<GetSharedActivitiesResponse> {
        return this.requestClient.post<GetSharedActivitiesResponse>(Urls.DeleteActivity, {}, { id: id, customerId: customerId });
    }
}